import DatePresetRows from "./DatePresetRows";
import { ListSubheader } from "@mui/material";
import {
  reportsV3DynamicDatePresetGroups,
  reportsV3StaticDatePresets,
} from "config";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const StaticDatePresetSection = ({ selectedPreset, onSelectPreset }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const groups = reportsV3DynamicDatePresetGroups();
  const presets = reportsV3StaticDatePresets();
  const inGroup = (group) => presets.filter((preset) => preset.group === group);
  const rows = [
    {
      group: groups.LAST,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_LAST, {
        default: "Last",
      }),
    },
    {
      group: groups.TO_DATE,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_TO_DATE, {
        default: "To date",
      }),
    },
  ].map((row) => ({ ...row, presets: inGroup(row.group) }));
  return (
    <React.Fragment>
      <ListSubheader disableSticky>
        {translateLabels(labels.REPORTS_V3_DATE_FILTER_STATIC_HEADING, {
          default: "Fixed filters",
        })}
      </ListSubheader>
      <DatePresetRows
        rows={rows}
        isSelected={(preset) => preset.key === selectedPreset}
        onSelect={(preset) => onSelectPreset(preset.key)}
      />
    </React.Fragment>
  );
};

export default StaticDatePresetSection;
